/**
 * Academic Year Context
 * Manages the currently selected academic year across the application
 */
import { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { examDb } from '../config/firebase';
import { COLLECTIONS } from '../config/constants';

const AcademicYearContext = createContext(null);

export function AcademicYearProvider({ children }) {
  const [currentAcademicYear, setCurrentAcademicYear] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAcademicYear = async () => {
      try {
        const configRef = doc(examDb, COLLECTIONS.SYSTEM_CONFIG, 'config');
        const configDoc = await getDoc(configRef);
        if (configDoc.exists()) {
          setCurrentAcademicYear(configDoc.data().currentAcademicYear || null);
        }
      } catch (err) {
        console.error('Error fetching academic year:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAcademicYear();
  }, []);

  const value = {
    currentAcademicYear,
    setCurrentAcademicYear,
    loading,
  };

  return (
    <AcademicYearContext.Provider value={value}>
      {children}
    </AcademicYearContext.Provider>
  );
}

export function useAcademicYear() {
  const context = useContext(AcademicYearContext);
  if (!context) {
    throw new Error('useAcademicYear must be used within an AcademicYearProvider');
  }
  return context;
}

export default AcademicYearContext;
